import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';

import IconBox from '../logo-box';
import ContentBox from '../content-box';
import InViewFade from 'ui-component/in-view-fade';

const timeline2007Img = `${process.env.REACT_APP_BASE_URL}/img/static/home-page/timeline-2007-2x.webp`;
const timeline2010Img = `${process.env.REACT_APP_BASE_URL}/img/static/home-page/timeline-2010-2x.webp`;
const timeline2016Img = `${process.env.REACT_APP_BASE_URL}/img/static/home-page/timeline-2016-2x.webp`;
const timeline2021Img = `${process.env.REACT_APP_BASE_URL}/img/static/home-page/timeline-2021-2x.webp`;
const timeline2024Img = `${process.env.REACT_APP_BASE_URL}/img/static/home-page/timeline-2024-2x.webp`;

const timelineDotStyle = {
    padding: '10px',
    background: 'linear-gradient(180deg, #E15C12 3.57%, #FCB336 100%)',
    borderStyle: 'none',
    boxShadow: '0px 0px 0px 4px rgb(225 92 18 / 10%), 0px 0px 0px 4px rgb(252 179 54 / 30%)',
    margin: '5px !important'
};

const TimelineDesktopView = () => (
    <Timeline position="alternate">
        <TimelineItem>
            <TimelineOppositeContent>
                <InViewFade direction="left" fraction={0.8} triggerOnce>
                    <IconBox iconSrc={timeline2007Img} yearDisplay="2007" displayOnLeft />
                </InViewFade>
            </TimelineOppositeContent>
            <TimelineSeparator>
                <TimelineDot sx={{ ...timelineDotStyle }} />
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
                <InViewFade direction="right" fraction={0.8} triggerOnce>
                    <ContentBox title="We are the First!" content="Hotmob builds the first premium mobile ad network in Hong Kong." />
                </InViewFade>
            </TimelineContent>
        </TimelineItem>
        <TimelineItem>
            <TimelineOppositeContent>
                <InViewFade direction="right" fraction={0.8} triggerOnce>
                    <IconBox iconSrc={timeline2010Img} yearDisplay="2010" />
                </InViewFade>
            </TimelineOppositeContent>
            <TimelineSeparator>
                <TimelineDot sx={{ ...timelineDotStyle }} />
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
                <InViewFade direction="left" fraction={0.8} triggerOnce>
                    <ContentBox
                        title="First Mover in the Market"
                        content="We keep innovating new ad formats.<br />E.g. HTML5, Pop Up ads, interactive ads"
                        displayOnLeft
                    />
                </InViewFade>
            </TimelineContent>
        </TimelineItem>
        <TimelineItem>
            <TimelineOppositeContent>
                <InViewFade direction="left" fraction={0.8} triggerOnce>
                    <IconBox yearDisplay="2013" displayOnLeft />
                </InViewFade>
            </TimelineOppositeContent>
            <TimelineSeparator>
                <TimelineDot sx={{ ...timelineDotStyle }} />
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
                <InViewFade direction="right" fraction={0.8} triggerOnce>
                    <ContentBox title="Leveraging Big Data" content="We revolutionize digital advertising to deliver accurate ads." />
                </InViewFade>
            </TimelineContent>
        </TimelineItem>
        <TimelineItem>
            <TimelineOppositeContent>
                <InViewFade direction="right" fraction={0.8} triggerOnce>
                    <IconBox iconSrc={timeline2016Img} yearDisplay="2016" />
                </InViewFade>
            </TimelineOppositeContent>
            <TimelineSeparator>
                <TimelineDot sx={{ ...timelineDotStyle }} />
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
                <InViewFade direction="left" fraction={0.8} triggerOnce>
                    <ContentBox
                        title="Years of Creation"
                        content="The launch of Alcanzar DSP & AdvanceEx Custom Audience Creations & DARTS Targeting."
                        displayOnLeft
                    />
                </InViewFade>
            </TimelineContent>
        </TimelineItem>
        <TimelineItem>
            <TimelineOppositeContent>
                <InViewFade direction="left" fraction={0.8} triggerOnce>
                    <IconBox yearDisplay="2018" displayOnLeft />
                </InViewFade>
            </TimelineOppositeContent>
            <TimelineSeparator>
                <TimelineDot sx={{ ...timelineDotStyle }} />
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
                <InViewFade direction="right" fraction={0.8} triggerOnce>
                    <ContentBox
                        title="Data Enrichment"
                        content="Leading external data provider, enabling companies empower their own CRM’s and marketing channels."
                    />
                </InViewFade>
            </TimelineContent>
        </TimelineItem>
        <TimelineItem>
            <TimelineOppositeContent>
                <InViewFade direction="right" fraction={0.8} triggerOnce>
                    <IconBox iconSrc={timeline2021Img} yearDisplay="2021" />
                </InViewFade>
            </TimelineOppositeContent>
            <TimelineSeparator>
                <TimelineDot sx={{ ...timelineDotStyle }} />
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
                <InViewFade direction="left" fraction={0.8} triggerOnce>
                    <ContentBox
                        title="AudSec Launch"
                        content="Audience profiling segmentation and curation platform from media campaign."
                        displayOnLeft
                    />
                </InViewFade>
            </TimelineContent>
        </TimelineItem>
        <TimelineItem>
            <TimelineOppositeContent>
                <InViewFade direction="left" fraction={0.8} triggerOnce>
                    <IconBox iconSrc={timeline2024Img} yearDisplay="2024" displayOnLeft />
                </InViewFade>
            </TimelineOppositeContent>
            <TimelineSeparator>
                <TimelineDot sx={{ ...timelineDotStyle }} />
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
                <InViewFade direction="right" fraction={0.8} triggerOnce>
                    <ContentBox title="Caterpillar Launch" content="AI-powered tool facilitates creative generation and production." />
                </InViewFade>
            </TimelineContent>
        </TimelineItem>
    </Timeline>
);

export default TimelineDesktopView;
